// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"608":"4f9f81df","787":"c3ebfa4c"}[chunkId] + ".chunk.js";
};